import React from "react";
import { NavLink } from "react-router-dom";
import officialLogo from "../assets/logo.png";
import favicon from "../assets/icon192.png";

const SidebarTop = ({ isOpen }) => {
  return (
    <div className={`flex items-center justify-center border-b-2 border-gray-200 bg-gradient-to-r from-blue-100 to-indigo-100 ${isOpen ? "p-6 w-72" : "p-6 w-20"} transition-all duration-300`}>
      <NavLink to="/dashboard">
        {isOpen ? (
          <img
            src={officialLogo}
            alt="Official Logo"
            className="transition-all duration-500 ease-in-out w-40 hover:scale-105"
          />
        ) : (
          <img
            src={favicon}
            alt="Placeholder Logo"
            className="transition-all duration-500 ease-in-out w-12 hover:scale-105"
          />
        )}
      </NavLink>
    </div>
  );
};

export default SidebarTop;